__webpack_require__.p = "/graph-a-demand-curve/";